var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "case-selector", attrs: { id: "case-selector" } },
    [
      _c(
        "header",
        { staticClass: "header" },
        [
          _c("span", [_vm._v("個案查詢")]),
          _vm._v(" "),
          _c(
            "v-icon",
            {
              staticClass: "header__close-btn",
              attrs: { color: "white" },
              on: {
                click: function($event) {
                  return _vm.control_case_selector_dialog(false)
                }
              }
            },
            [_vm._v("\n            icon-close\n        ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "case-selector__content" },
        [
          _c(
            "div",
            { staticClass: "control" },
            [
              _c("v-autocomplete", {
                attrs: { label: "個案類別", items: _vm.categories },
                model: {
                  value: _vm.category_selected,
                  callback: function($$v) {
                    _vm.category_selected = $$v
                  },
                  expression: "category_selected"
                }
              }),
              _vm._v(" "),
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "close-on-click": false,
                    "offset-y": "",
                    "min-width": "290px"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              {
                                attrs: { label: "開始時間", readonly: "" },
                                model: {
                                  value: _vm.model_start_time,
                                  callback: function($$v) {
                                    _vm.model_start_time = $$v
                                  },
                                  expression: "model_start_time"
                                }
                              },
                              on
                            ),
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "v-input__icon v-input__icon--append",
                                  attrs: { slot: "append" },
                                  slot: "append"
                                },
                                [
                                  _c("v-icon", { attrs: { color: "black" } }, [
                                    _vm._v(
                                      "\n                                icon-time-setting\n                            "
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.start_time_menu,
                    callback: function($$v) {
                      _vm.start_time_menu = $$v
                    },
                    expression: "start_time_menu"
                  }
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-date-picker",
                    {
                      model: {
                        value: _vm.model_start_time,
                        callback: function($$v) {
                          _vm.model_start_time = $$v
                        },
                        expression: "model_start_time"
                      }
                    },
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.cancel_date_pick("start_time")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("__time_choose.cancel")) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.toggle_generate_time_durations(
                                "start_time"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("__time_choose.decide")) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "close-on-click": false,
                    "nudge-right": 40,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "290px"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              {
                                attrs: { label: "結束時間", readonly: "" },
                                model: {
                                  value: _vm.model_end_time,
                                  callback: function($$v) {
                                    _vm.model_end_time = $$v
                                  },
                                  expression: "model_end_time"
                                }
                              },
                              on
                            ),
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "v-input__icon v-input__icon--append",
                                  attrs: { slot: "append" },
                                  slot: "append"
                                },
                                [
                                  _c("v-icon", { attrs: { color: "black" } }, [
                                    _vm._v(
                                      "\n                                icon-time-setting\n                            "
                                    )
                                  ])
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.end_time_menu,
                    callback: function($$v) {
                      _vm.end_time_menu = $$v
                    },
                    expression: "end_time_menu"
                  }
                },
                [
                  _vm._v(" "),
                  _c(
                    "v-date-picker",
                    {
                      model: {
                        value: _vm.model_end_time,
                        callback: function($$v) {
                          _vm.model_end_time = $$v
                        },
                        expression: "model_end_time"
                      }
                    },
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.cancel_date_pick("end_time")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("__time_choose.cancel")) +
                              "\n                    "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.toggle_generate_time_durations(
                                "end_time"
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("__time_choose.decide")) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            staticClass: "case-table",
            attrs: { headers: _vm.headers, items: _vm.cases },
            scopedSlots: _vm._u([
              {
                key: "item.report_form",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "" },
                        on: {
                          click: function($event) {
                            return _vm.edit_report_form(item)
                          }
                        }
                      },
                      [_vm._v("\n                    edit\n                ")]
                    )
                  ]
                }
              },
              {
                key: "item.warning_form",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "" },
                        on: {
                          click: function($event) {
                            return _vm.edit_warn_form(item)
                          }
                        }
                      },
                      [_vm._v("\n                    edit\n                ")]
                    )
                  ]
                }
              },
              {
                key: "item.alert_form",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "" },
                        on: {
                          click: function($event) {
                            return _vm.edit_alert_form(item)
                          }
                        }
                      },
                      [_vm._v("\n                    edit\n                ")]
                    )
                  ]
                }
              },
              {
                key: "item.action",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { small: "" },
                        on: {
                          click: function($event) {
                            return _vm.choose_case(item)
                          }
                        }
                      },
                      [_vm._v("\n                    search\n                ")]
                    )
                  ]
                }
              },
              {
                key: "no-data",
                fn: function() {
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "primary" },
                        on: { click: _vm.initialize }
                      },
                      [
                        _vm._v(
                          "\n                    重新整理\n                "
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "684px" },
          model: {
            value: _vm.dialog_form,
            callback: function($$v) {
              _vm.dialog_form = $$v
            },
            expression: "dialog_form"
          }
        },
        [
          _c(
            "header",
            { staticClass: "header" },
            [
              _c("span", { staticClass: "header__title" }, [
                _vm._v(_vm._s(_vm.form_name))
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-icon",
                {
                  staticClass: "header__close-btn",
                  attrs: { color: "white" },
                  on: {
                    click: function($event) {
                      _vm.dialog_form = false
                    }
                  }
                },
                [_vm._v("\n                icon-close\n            ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            staticClass: "case-table",
            attrs: { headers: _vm.form_headers, items: _vm.form_data },
            scopedSlots: _vm._u([
              {
                key: "item.file_path",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-btn",
                      {
                        staticClass: "download-btn",
                        attrs: { "x-small": "", color: "secondary", dark: "" }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.CASE_FILE_URL + item.filepath,
                              title: "download",
                              target: "_blank"
                            }
                          },
                          [
                            _vm._v(
                              "\n                        Download\n                    "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "item.tra_file_path",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c(
                      "v-btn",
                      {
                        staticClass: "download-btn",
                        attrs: { "x-small": "", color: "secondary", dark: "" }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: _vm.CASE_FILE_URL + item.filepath,
                              target: "_blank",
                              download: ""
                            }
                          },
                          [
                            _vm._v(
                              "\n                        Download\n                    "
                            )
                          ]
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }